// src/forms/companyProfileConfig.js

const ProductConfig = [{ 
  name: 'prices_buy_uom_id',
  label: 'Buy Unit of measure',
  type: 'select',
  defaultValue: '',
  
  rules: { required: 'Unit of measure  is required' },
},
{

  name: 'prices_sell_uom_id',
  label: 'Sell Unit of measure ',
  type: 'select',
  defaultValue: '',
  
  rules: { required: 'Unit of meausre  is required' },
},

{
  name: 'buy_price', 
  label: 'Buy Price',
  type: 'text',
  defaultValue: '',
  placeholder: 'Order Price',
  rules: {required: 'Order Price is required'},
},
     
{
  name: 'sell_price', // Changed from 'phone_numbers' to 'phone_number'
  label: 'Sell Price',
  type: 'text',
  defaultValue: '',
  placeholder: 'Selling  Price',
  rules: {required: 'Selling Price is required'},
},

{
  name: 'reorder_quantity', // Changed from 'phone_numbers' to 'phone_number'
  label: 'Re order Quantity',
  type: 'text',
  defaultValue: '',
  placeholder: 'Reorder Quantity',
  rules: {required: 'Selling Price is required'},
},
{

  name: 'quantity_instock', // Changed from 'phone_numbers' to 'phone_number'
  label: 'Quantity in stock',
  type: 'text',
  defaultValue: '',
  placeholder: 'Quantity in stock',
  // rules: {required: 'Selling Price is required'},
},
       
      
];
export default ProductConfig;
  